import { Injectable } from '@angular/core';

import { ApiApplication } from '@careconne/core/configs/router.config';

import { ApiService } from '../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class TtlMstService {
  constructor(private readonly http: ApiService) {}

  getTitleTagMasterList(param: any) {
    return this.http.post(ApiApplication.TTL_MST.CONTROLLER + ApiApplication.TTL_MST.TITLE_TAG_MASTER_LIST, param);
  }

  getRefreshTitleTagMasterList(param: any) {
    return this.http.post(ApiApplication.TTL_MST.CONTROLLER + ApiApplication.TTL_MST.TITLE_MST_REFRESH, param);
  }

  getTitleTagMasterListFromCommonApi(param: any) {
    return this.http.post(ApiApplication.TTL_MST.CONTROLLER + ApiApplication.TTL_MST.TITLE_MST_CK, param);
  }

  saveTitleTagMaster(param: any) {
    return this.http.post(ApiApplication.TTL_MST.CONTROLLER, param);
  }

  getTitleSetting(param: any) {
    return this.http.post(ApiApplication.TTL_MST.CONTROLLER + ApiApplication.TTL_MST.TITLE_SETTING, param);
  }
}
